import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import {logout, onForbidden} from '../account/login';
import _ from 'lodash';
import {getContinentByCountry} from "../common/location";

//- Actions
export const fetchGetOrgsForRequestSuccess = createAction('FETCH_GET_ORGS_FOR_REQUEST_SUCCESS');
export const fetchGetOrgsForRequestFailed = createAction('FETCH_GET_ORGS_FOR_REQUEST_FAILED');
export const fetchGetOrgsForRequest = createAction(
    'FETCH_GET_ORGS_FOR_REQUEST',
    (country, orgName) => Api.getOrgsForRequest(country, orgName),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrgsForRequestSuccess,
        onFail: fetchGetOrgsForRequestFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const resetOrganizations = createAction('FETCH_GET_ORGS_FOR_REQUEST');

export const fetchGetAGsForRequestSuccess = createAction('FETCH_GET_AGS_FOR_REQUEST_SUCCESS');
export const fetchGetAGsForRequestFailed = createAction('FETCH_GET_AGS_FOR_REQUEST_FAILED');
export const fetchGetAGsForRequest = createAction(
    'FETCH_GET_AGS_FOR_REQUEST',
    (orgId) => Api.getAGsForRequest(orgId),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAGsForRequestSuccess,
        onFail: fetchGetAGsForRequestFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetOrgByDomainSuccess = createAction('FETCH_GET_ORG_BY_DOMAIN_SUCCESS');
export const fetchGetOrgByDomainFailed = createAction('FETCH_GET_ORG_BY_DOMAIN_FAILED');
export const fetchGetOrgByDomain = createAction(
    'FETCH_GET_ORG_BY_DOMAIN',
    (domain) => Api.getOrgByDomain(domain),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrgByDomainSuccess,
        onFail: fetchGetOrgByDomainFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const resetAccreditationGroups =  createAction('RESET_ACCREDITATION_GROUPS');
export const resetOrganization =  createAction('RESET_ORGANIZATION');

//- State
const initialState = {
    organizations: null,
    accreditationGroups: null,
    error: null,
    fetching: false,
    organization: null,
    AGError: null
};

//- Reducers
export default handleActions({
    FETCH_GET_ORGS_FOR_REQUEST: (state) => {
        return {...state, organizations: null};
    },
    FETCH_GET_ORGS_FOR_REQUEST_SUCCESS: (state, action) => {
        return {...state, organizations: action.payload};
    },
    FETCH_GET_ORGS_FOR_REQUEST_FAILED: (state, action) => {
        return {...state, organizations: null, error: action.payload};
    },
    FETCH_GET_AGS_FOR_REQUEST: (state) => {
        return {...state, accreditationGroups: null, AGError: null};
    },
    FETCH_GET_AGS_FOR_REQUEST_SUCCESS: (state, action) => {
        return {...state, accreditationGroups: action.payload, AGError: null};
    },
    FETCH_GET_AGS_FOR_REQUEST_FAILED: (state, action) => {
        return {...state, accreditationGroups: null, AGError: action.payload};
    },
    FETCH_GET_ORG_BY_DOMAIN: (state) => {
        return {...state, organization: null, error: null, fetching: true};
    },
    FETCH_GET_ORG_BY_DOMAIN_SUCCESS: (state, action) => {
        return {...state, organization: action.payload, error: null, fetching: false};
    },
    FETCH_GET_ORG_BY_DOMAIN_FAILED: (state, action) => {
        return {...state, organization: null, error: action.payload, fetching: false};
    },
    RESET_ACCREDITATION_GROUPS: (state) => {
        return {...state, accreditationGroups: null, AGError: null}
    },
    RESET_ORGANIZATION: (state) => {
        return {...state, organization: null}
    }

}, initialState);

//- Selectors
export const getAccreditationRequestOrgData = state => state.accreditationRequestOrgData;

export const getOrgsForRequest = state => getAccreditationRequestOrgData(state).organizations;

export const getAGsForRequestError = state => getAccreditationRequestOrgData(state).AGError;

export const getOrgsSelectOptionsForRequests = state => {
    let data = getOrgsForRequest(state);

    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, org => ({value: org.id, label: org.name, bavaManaged: !_.isNil(org.managingOrganizationId)}));
};
export const getAGsForRequest = state => getAccreditationRequestOrgData(state).accreditationGroups;

export const getAGsSelectOptionsForRequests = state => {
    if (_.isNil(getAGsForRequest(state))) {
        return null;
    }

    return _.map(getAGsForRequest(state), AG => ({value: AG.id, label: AG.name}));
};

export const getOrgByDomainData = state => getAccreditationRequestOrgData(state).organization;

export const getOrgByDomainOption = state => {
    let org = getOrgByDomainData(state);
    if (_.isNil(org)){
        return null;
    }

    return org.id;
};

export const getOrgByDomainCountryOption = state => {
    let org = getOrgByDomainData(state);
    if (_.isNil(org)){
        return null;
    }

    return {countryCode: org.address.countryCode, continent: getContinentByCountry(org.address.countryCode, state)};
};

export const getOrgByDomainNameOption = state => {
    let org = getOrgByDomainData(state);
    if (_.isNil(org)){
        return null;
    }

    return org.name;
};

export const loadingOrgByDomain = state => getAccreditationRequestOrgData(state).fetching;



// WEBPACK FOOTER //
// ./src/reducers/applicantAccreditations/accreditationRequestOrgData.js